{
  "auth": {
    "agree": "Eu aceito.",
    "createAccount": "Criar conta",
    "createNewAccount": "Criar uma nova conta",
    "email": "Email",
    "login": "Entrar",
    "password": "Senha",
    "recover_password": "Recuperar senha",
    "sign_up": "Cadastrar-se",
    "keep_logged_in": "Mantenha-me conectado",
    "termsOfUse": "Termos de uso.",
    "reset_password": "Redefinir senha"
  },
  "404": {
    "title": "Esta página está pescando.",
    "text": "Se você acha que isso não está certo, envie-nos uma mensagem em ",
    "back_button": "Voltar para o painel"
  },
  "typography": {
    "primary": "Estilos de texto primários",
    "secondary": "Estilos de texto secundários"
  },
  "dashboard": {
    "versions": "Versões",
    "setupRemoteConnections": "Configurar Conexões Remotas",
    "currentVisitors": "Visitantes Atuais",
    "charts": {
      "trendyTrends": "Tendências na moda",
      "showInMoreDetail": "Mostrar em mais detalhes",
      "showInLessDetail": "Mostrar em menos detalhes",
      "loadingSpeed": "Velocidade de carregamento",
      "topContributors": "Principais colaboradores",
      "showNextFive": "Mostrar próximos cinco",
      "commits": "Commits"
    },
    "info": {
      "componentRichTheme": "tema rico em componentes",
      "completedPullRequests": "solicitações de pull concluídas",
      "users": "usuários",
      "points": "pontos",
      "units": "unidades",
      "exploreGallery": "Explorar galeria",
      "viewLibrary": "Ver Biblioteca",
      "commits": "commits",
      "components": "componentes",
      "teamMembers": "membros da equipe"
    },
    "tabs": {
      "overview": {
        "title": "Visão Geral",
        "built": "Construído com o framework Vue.js",
        "free": "Totalmente gratuito para todos",
        "fresh": "Design fresco e nítido",
        "mobile": "Responsivo e otimizado para dispositivos móveis",
        "components": "Toneladas de componentes úteis",
        "nojQuery": "Completamente livre de jQuery"
      },
      "billingAddress": {
        "title": "Endereço de Cobrança",
        "personalInfo": "Informação Pessoal",
        "firstName": "Nome e Sobrenome",
        "email": "Email",
        "address": "Endereço",
        "companyInfo": "Informação da Empresa",
        "city": "Cidade",
        "country": "País",
        "infiniteConnections": "Conexões infinitas",
        "addConnection": "Adicionar Conexão"
      },
      "bankDetails": {
        "title": "Detalhes Bancários",
        "detailsFields": "Campos de Detalhes",
        "bankName": "Nome do Banco",
        "accountName": "Nome da Conta",
        "sortCode": "Código de Ordenação",
        "accountNumber": "Número da Conta",
        "notes": "Notas",
        "sendDetails": "Enviar Detalhes"
      }
    },
    "navigationLayout": "layout de navegação",
    "topBarButton": "Barra Superior",
    "sideBarButton": "Barra Lateral"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "Inglês",
    "spanish": "Espanhol",
    "simplified_chinese": "Chinês Simplificado",
    "persian": "Persa"
  },
  "menu": {
    "auth": "Autenticação",
    "buttons": "Botões",
    "timelines": "Linhas do Tempo",
    "dashboard": "Painel de Controle",
    "billing": "Vendas",
    "login": "Entrar",
    "signUp": "Cadastrar-se",
    "preferences": "Preferências",
    "payments": "Pagamentos",
    "pricing-plans": "Planos de Preços",
    "login-singup": "Entrar/Cadastrar",
    "404": "Páginas 404",
    "faq": "FAQ",
    "clients": "Clientes",
    "sales": "Vendas",
    "finance": "Finanças",
    "financeDashboard": "Painel de Finanças",
    "financialReports": "Relatórios Financeiros",
    "activeUsers": "Usuários Ativos",
    "staff": "Funcionários",
    "invitations": "Convites",
    "setup": "Configuração",
    "items": "Itens",
    "roles": "Funções",
    "configurations": "Configurações",
    "inventory": "Inventário",
    "inventoryDashboard": "Painel",
    "inventoryItems": "Itens de inventário",
    "inventoryLocations": "Locais de inventário",
    "stockIn": "Entrada de estoque",
    "stockOut": "Saída de estoque",
    "transfers": "Transferências",
    "procurement": "Compras",
    "suppliers": "Fornecedores",
    "expenses": "Despesas",
    "commissions": "Comissões",
    "catalog": "Catálogo",
    "products": "Produtos",
    "unitsOfMeasure": "Unidades de medida",
    "servicesCatalog": "Serviços",
    "salesOrders": "Pedidos de venda",
    "invoices": "Notas fiscais",
    "financeOverview": "Visão geral",
    "financePayments": "Pagamentos",
    "transactions": "Transações",
    "reports": "Relatórios",
    "financeReports": "Relatórios financeiros",
    "itemsReports": "Itens",
    "usersAndRoles": "Usuários e permissões",
    "systemUsers": "Usuários ativos",
    "rolesAndPermissions": "Funções e permissões",
    "settingsApplication": "Configurações",
    "companySettings": "Dados da empresa"
  },
  "messages": {
    "all": "Ver todas as mensagens",
    "new": "Novas mensagens de {name}",
    "mark_as_read": "Marcar como Lido"
  },
  "navbar": {
    "messageUs": "Perguntas de desenvolvimento web:",
    "repository": "Repositório GitHub"
  },
  "notifications": {
    "all": "Ver todas as notificações",
    "mark_as_read": "Marcar como lida",
    "sentMessage": "enviou uma mensagem",
    "uploadedZip": "fez upload de um novo arquivo Zip com {type}",
    "startedTopic": "iniciou um novo tópico"
  },
  "user": {
    "language": "Mudar Idioma",
    "logout": "Sair",
    "profile": "Meu Perfil",
    "settings": "Configurações",
    "billing": "Vendas",
    "faq": "FAQ",
    "helpAndSupport": "Ajuda & Suporte",
    "projects": "Projetos",
    "account": "Conta",
    "explore": "Explorar"
  },
  "treeView": {
    "basic": "Básico",
    "icons": "Icones",
    "selectable": "Selecionável",
    "editable": "Editável",
    "advanced": "Advançado"
  },
  "chat": {
    "title": "Gráficos"
  },
  "helpAndSupport": "Ajuda & Suporte",
  "aboutVuesticAdmin": "Sobre Vuestic Admin",
  "search": {
    "placeholder": "Buscar..."
  },
  "expense": {
    "tabs": {
      "expenses": "Despesas",
      "expenseItems": "Itens de despesa",
      "expenseCategories": "Categorias de despesa"
    },
    "recordsPlaceholder": "Os registros de despesas estarão disponíveis nesta guia em uma alteração separada.",
    "records": {
      "registrationHeading": "Cabeçalho da despesa",
      "referenceNumber": "Número de referência",
      "expenseDate": "Data da despesa",
      "totalAmount": "Valor total",
      "notes": "Observações",
      "linesHeading": "Linhas da despesa",
      "addLineHeading": "Adicionar linha de despesa",
      "linesEmptyState": "Nenhuma linha de despesa adicionada. Use o formulário acima para adicionar.",
      "removeLineConfirmTitle": "Remover linha",
      "removeLineConfirmMessage": "Tem certeza de que deseja remover esta linha de despesa?",
      "removeLineConfirmOk": "Remover",
      "linesCountSuffix": "linha(s)",
      "selectCategory": "Selecione a categoria",
      "selectExpenseItem": "Selecione o item de despesa",
      "validationSelectCategory": "Selecione uma categoria de despesa.",
      "validationSelectItem": "Selecione um item de despesa.",
      "validationAmountRequired": "O valor é obrigatório.",
      "validationAmountPositive": "O valor deve ser maior que zero.",
      "validationDescriptionRequired": "A descrição é obrigatória.",
      "validationFixLine": "Corrija os detalhes da linha antes de adicionar.",
      "addLine": "Adicionar linha",
      "submit": "Registrar despesa",
      "submitConfirmTitle": "Confirmar despesa",
      "submitConfirmMessage": "Registrar esta despesa no valor de {total} com {count} linha(s)?",
      "submitConfirmOk": "Registrar despesa",
      "expenseItem": "Item de despesa",
      "amount": "Valor",
      "displayDetailed": "Detalhado",
      "displaySummary": "Resumo",
      "registerExpense": "Registrar despesa",
      "search": "Buscar",
      "filterExpenseNumber": "Número da despesa",
      "filterReferenceNumber": "Número de referência",
      "filterStartDate": "Data inicial",
      "filterEndDate": "Data final",
      "applyFilters": "Aplicar filtros",
      "clearFilters": "Limpar",
      "expenseNumber": "Número da despesa",
      "viewDetails": "Ver detalhes",
      "resultsSuffix": "resultados.",
      "perPage": "Por página",
      "listLoadFailed": "Não foi possível carregar as despesas. Tente novamente.",
      "listEmptySummary": "Nenhum registro de despesa encontrado para os filtros atuais.",
      "listEmptyDetailed": "Nenhuma linha de despesa encontrada para os filtros atuais.",
      "saveFailed": "Não foi possível salvar a despesa. Tente novamente.",
      "noDetail": "Nenhum detalhe de despesa disponível."
    },
    "statusActive": "Ativo",
    "statusInactive": "Inativo",
    "yes": "Sim",
    "no": "Não",
    "modal": {
      "createExpenseItem": "Criar item de despesa",
      "editExpenseItem": "Editar item de despesa",
      "createExpenseCategory": "Criar categoria de despesa",
      "editExpenseCategory": "Editar categoria de despesa",
      "registerExpense": "Registrar despesa",
      "expenseLinesTitle": "Linhas da despesa"
    },
    "columns": {
      "name": "Nome",
      "code": "Código",
      "description": "Descrição",
      "status": "Status",
      "category": "Categoria",
      "defaultAmount": "Valor padrão",
      "item": "Item"
    },
    "form": {
      "expenseCategory": "Categoria de despesa",
      "name": "Nome",
      "code": "Código",
      "defaultAmount": "Valor padrão",
      "description": "Descrição",
      "active": "Ativo",
      "save": "Salvar",
      "cancel": "Cancelar"
    },
    "categoriesLoadFailed": "Não foi possível carregar as categorias de despesa. Tente novamente.",
    "itemsLoadFailed": "Não foi possível carregar os itens de despesa. Tente novamente.",
    "validation": {
      "atLeastOneLine": "Adicione pelo menos uma linha de despesa.",
      "expenseDateRequired": "A data da despesa é obrigatória.",
      "expenseDateNotInFuture": "A data da despesa não pode ser posterior a hoje.",
      "totalMustBePositive": "O valor total deve ser maior que zero."
    },
    "toasts": {
      "categoryCreated": "Categoria de despesa criada com sucesso",
      "categoryUpdated": "Categoria de despesa atualizada com sucesso",
      "categoryDeleted": "Categoria de despesa excluída com sucesso",
      "itemCreated": "Item de despesa criado com sucesso",
      "itemUpdated": "Item de despesa atualizado com sucesso",
      "itemDeleted": "Item de despesa excluído com sucesso",
      "expenseCreated": "Despesa registrada com sucesso"
    }
  },
  "inventoryHealth": {
    "pageTitle": "Painel de inventário",
    "pageSubtitle": "Problemas de estoque e validade que precisam de atenção.",
    "pageSubtitleAtLocation": "Problemas de estoque e validade que precisam de atenção em {location}.",
    "asOfDate": "Em {date}",
    "permissionDenied": "Você não tem permissão para ver as contagens de saúde do inventário.",
    "selectWarehouse": "Selecione um depósito para ver as contagens de saúde do inventário dessa localização.",
    "loadError": "Não foi possível carregar as contagens de saúde do inventário.",
    "retry": "Tentar novamente",
    "allClear": "Não há problemas de estoque baixo ou validade nesta localização.",
    "allItems": "Todos os itens",
    "filterToolbarAria": "Filtros de estoque e validade",
    "stockSection": "Estoque",
    "expirySection": "Validade",
    "cardClear": "Tudo certo",
    "cardAlert": "Atenção",
    "attentionSummary": "itens precisam de atenção",
    "badgeNeedsAttention": "Precisa de atenção",
    "badgePlanAction": "Planejar ação",
    "badgeTakeAction": "Agir",
    "lowStock": "Estoque baixo",
    "lowStockSubtitle": "Itens no nível de reposição ou abaixo dele",
    "outOfStock": "Sem estoque",
    "outOfStockSubtitle": "Nenhum estoque disponível nesta localização",
    "inStock": "Em estoque",
    "expiringSoon": "A vencer em breve",
    "expiringSoonSubtitle": "Lotes na janela de alerta de validade",
    "expiringSoonSubtitleDays": "Lotes que vencem em {days} dias",
    "expired": "Vencido",
    "expiredSubtitle": "Itens com lotes vencidos",
    "expiredSubtitleBatches": "{count} lotes vencidos em {location}",
    "viewLowStock": "Ver itens com estoque baixo",
    "viewOutOfStock": "Ver itens sem estoque",
    "viewExpiring": "Ver itens a vencer",
    "viewExpired": "Ver itens vencidos",
    "glanceTitle": "Inventário em resumo",
    "totalItems": "Total de itens",
    "totalItemsSubtitle": "Em todas as categorias",
    "totalBatches": "Total de lotes",
    "totalBatchesSubtitle": "Lotes ativos",
    "totalLocations": "Total de localizações",
    "totalLocationsSubtitle": "Localizações de estoque ativas",
    "totalLocationsSubtitleNamed": "{location}",
    "totalLocationsSubtitleOthers": "{location} + {count} outras",
    "itemsInStock": "Itens em estoque",
    "itemsInStockSubtitle": "{percent}% do total de itens",
    "stockBreakdownTitle": "Divisão de estoque",
    "totalIssues": "Total de problemas",
    "quickActionsTitle": "Ações rápidas",
    "quickActionAdjustStock": "Ajustar estoque",
    "quickActionViewReports": "Ver relatórios",
    "quickActionManageItems": "Gerenciar itens",
    "quickActionStockIn": "Entrada de estoque",
    "quickActionCreatePurchaseOrder": "Criar pedido de compra",
    "focusHintExpired": "Lotes vencidos estão destacados.",
    "focusHintExpiringSoon": "Lotes a vencer em breve estão destacados.",
    "stockByLocationEmpty": "Nenhum estoque por localização foi retornado para este item.",
    "stockByLocationLoadError": "Falha ao carregar o estoque por localização.",
    "viewItems": "Ver itens",
    "cardAria": "{label}: {count}. Abrir itens filtrados."
  }
}
